/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemSelectionComponent } from '../components/itemselection/itemselection.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemSelectionService } from '../services/itemselection.service';
import { ItemDetailService } from '../../items/services/itemdetail.service';
import { SpinnerModule } from './../../../../shared/spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule ,
    ReactiveFormsModule,
    SpinnerModule
  ],
  declarations: [ ItemSelectionComponent ],
    exports: [ItemSelectionComponent, CommonModule],
    providers: [ItemSelectionService , ItemDetailService]
})

export class ItemSelectionModule { }
